export enum TenantProcess {
  None = 0,
  AnnualPlan = 3,
  Library = 4,
  ProcessSuggestions = 5,
  ControlEvidenceAudit = 6,
  ControlDocumentationAudit = 7,
  TaskEvidenceAudit = 9,
  AuditFindings = 10,
  FrameworkAudit = 12,
  // Mirror of AIProcessType.InternalAuditControlAudit. Deliberately NO copilot panel action: the
  // run is unattended and its status lives in the audit's Prepare and Execute tab.
  InternalAuditControlAudit = 11,
  // Mirror of AIProcessType.AuditCriteriaGeneration: the whole-standard criteria generation the
  // Frameworks > Audit criteria tab starts and polls. No copilot panel action either.
  AuditCriteriaGeneration = 13,
  // Mirror of AIProcessType.Insight: the advice card on an entity's own screen. Tenant-scoped, and
  // deliberately NO copilot panel action either: the card starts the run and reads the answer.
  Insight = 14,
  // Mirror of AIProcessType.DocumentSummary: the two lines under one document in the documents
  // room. Tenant-scoped and keyed on the link, and no copilot panel action: the room starts the run
  // per document and reads the answers.
  DocumentSummary = 15,
  // Mirror of AIProcessType.AutomationDrafting: the "Draft automation" panel action (phase 27), a Skill in
  // SkillControl drafted from a control, a requirement or the annual plan. User-scoped, keyed on the item.
  AutomationDrafting = 16,
  // Mirror of AIProcessType.KpiReport (PLAN-070): the KPI report PDF as a process. User-scoped, keyed on the data
  // report job (a reservation id until the job exists).
  KpiReport = 17,
  // Mirror of AIProcessType.SupplierIncidents and SupplierCompliance (PLAN-073): the two investigations of a Supplier
  // asset, offered in the panel of its detail scene. User-scoped, keyed on the asset.
  SupplierIncidents = 18,
  SupplierCompliance = 19,
  // Mirror of AIProcessType.EntityEvidenceAudit (PLAN-077): the AI evidence audit of one asset, risk, process,
  // objective or processing activity against its audit criteria. User-scoped, keyed on the entity.
  EntityEvidenceAudit = 20,
}

export enum TenantProcessStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
  Cancelled = 3,
  Failed = 4,
}
